import manifest from '@content/lessons.json';

export type LessonMeta = {
  slug: string;
  order: number;
  eyebrow: string;
  title: string;
  subtitle: string;
  image: string | null;
};

export const lessons: LessonMeta[] = manifest as LessonMeta[];
export const lessonBySlug: Record<string, LessonMeta> = Object.fromEntries(
  lessons.map((l) => [l.slug, l]),
);

// Vite splits each lesson HTML into its own chunk (loaded on demand).
const fragmentLoaders = import.meta.glob('../../content/lessons/*.html', {
  query: '?raw',
  import: 'default',
}) as Record<string, () => Promise<string>>;

export async function loadLessonHtml(slug: string): Promise<string> {
  const key = Object.keys(fragmentLoaders).find((k) => k.endsWith(`/${slug}.html`));
  if (!key) throw new Error(`Unknown lesson: ${slug}`);
  return fragmentLoaders[key]();
}

export const JOURNAL_PROMPTS: { key: string; label: string }[] = [
  { key: 'learned', label: 'Hoy he aprendido…' },
  { key: 'worked', label: 'Lo que ha funcionado…' },
  { key: 'problem', label: 'El problema que he encontrado…' },
  { key: 'improve', label: 'Mi mejora para mañana…' },
];
